import { ArrowRightIcon, LockIcon, PencilIcon } from "@phosphor-icons/react";
import { Col, Flex, Row, Typography } from "antd";
import { ReactNode, useRef } from "react";
import { useHover } from "usehooks-ts";

export function SettingsItem<T>({
  title,
  content,
  icon,
  onClick,
  editable = false,
  locked = false,
  alwaysShowEditIcon = false,
}: {
  title: string;
  content: ReactNode;
  icon?: ReactNode;
  onClick?: (() => void) | null;
  editable?: boolean;
  locked?: boolean;
  alwaysShowEditIcon?: boolean;
}) {
  const ref = useRef(null);
  const isHover = useHover(ref);

  const handleClick = () => {
    onClick?.();
  };
  return (
    <Row
      gutter={[10, 10]}
      ref={ref}
      style={{
        cursor: editable ? "pointer" : "default",
        width: "100%",
      }}
      onClick={handleClick}
    >
      <Col sm={24} md={12}>
        <Flex align="center" gap={10}>
          <span style={{ opacity: 0.6 }} className="anticon">
            {icon}
          </span>
          <Typography.Text style={{ fontSize: "1.4em" }}>
            {title}
          </Typography.Text>
        </Flex>
      </Col>
      <Col sm={24} md={12}>
        <Flex align="center" justify="space-between" gap={10}>
          <Typography.Text
            style={{
              fontSize: "1.4em",
              textAlign: "left",
            }}
          >
            {content}
          </Typography.Text>
          <span style={{ opacity: 0.7 }}>
            {isHover && onClick && !editable && <ArrowRightIcon size={26} />}
            {(alwaysShowEditIcon || isHover) && editable && !locked && (
              <PencilIcon size={26} />
            )}
            {isHover && locked && <LockIcon size={26} />}
          </span>
        </Flex>
      </Col>
    </Row>
  );
}
